/* unplugin-vue-components disabled */import script from "./editTable.vue?vue&type=script&setup=true&name=GenEdit&lang=js"
export * from "./editTable.vue?vue&type=script&setup=true&name=GenEdit&lang=js"

const __exports__ = script;

export default __exports__